import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import moment from 'moment';
import { SpinnerVisibilityService } from 'ng-http-loader';

@Component({
  selector: 'app-user-my-orders',
  templateUrl: './user-my-orders.component.html',
  styleUrls: ['./user-my-orders.component.scss']
})
export class UserMyOrdersComponent {
  mOrderDetail: any;
  state: any;
  orderId: any = null;
  pdfData = {
    content: [
      'Hello, this is a sample PDF generated using pdfmake.'
    ]
  };
  
  constructor(private spinner: SpinnerVisibilityService, private route: ActivatedRoute) {
    this.route.params.subscribe((data:any)=>{
      if(data['id']){
        this.orderId = data['id']
      }
    })
  }

  downloadAsPDF(event: any) {
    this.mOrderDetail = event;
    this.spinner.show();
    setTimeout(() => {
        const doc = new jspdf("p", "px", "a4"); // Use 'px' as units for page dimensions
        // Define options for html2canvas
        const options = {
            scale: 2 // Adjust the scale factor as needed for better quality
        };
        const element: any = document.getElementById('pdfTable');
        $('#pdfTable').removeAttr('hidden');
        // Convert HTML to canvas using html2canvas
        html2canvas(element, options).then(canvas => {
            // Calculate the page width and height based on the aspect ratio
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = (canvas.height * pageWidth) / canvas.width;
            // Calculate the scale factor based on the device's screen size
            const scaleFactor = Math.min(
                doc.internal.pageSize.getWidth() / canvas.width,
                doc.internal.pageSize.getHeight() / canvas.height
            );
            // Add the canvas to the PDF document
            const imageData = canvas.toDataURL('image/png');
            doc.addImage(imageData, 'PNG', 0, 0, canvas.width * scaleFactor, canvas.height * scaleFactor);
            // Save the PDF document
            const date = new Date();
            doc.save(this.mOrderDetail.id + '_' + date.getTime() + '.pdf');
            this.spinner.hide();
            $('#pdfTable').attr('hidden', 'true');
        });
    }, 200);
}

  showDate(val: any) {
    return moment(val).format('MMM , DD YYYY');
  }
}
